import { find, differenceWith, includes } from 'lodash';

const initialState = {
  questions: [],
  tags: [],
  metrics: [],
};

const reducer = (state = initialState, action = {}) => {
  return state;
};

export const getQuestionFromTags = (questions, tags) => {
  let question = questions[0];
  tags.forEach(tag => {
    const answer = find(question.options, { tag });
    question = getQuestionForId(questions, answer.toQuestion);
  });

  return question;
};

export const getMetricsForTags = (metrics, tags) => {
  return differenceWith(metrics, tags, (m, t) => {
    return !includes(m.tags, t);
  });
};

export const getQuestionForId = (questions, id) => {
  return find(questions, { id });
};

export const getTagForId = (tags, id) => {
  return find(tags, { id });
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/reducer.js